import React, { Suspense } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { IconSearch } from "../icons/svg";
import ContactList from "./contact-list.jsx";
import lodash from 'lodash'
import { Topic } from '../tinode/topic'
import { removeAccents } from '../lib/strformat'
import { CONTACT_LIST_SHOW_MODE } from '../tinode/constants.js'

class ShareContacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contacts: [],
      topicSelected: ''
    }

    this.handleSearch = this.handleSearch.bind(this);
    this.handleSelected = this.handleSelected.bind(this);
    this.handleSendContact = this.handleSendContact.bind(this);
  }

  componentDidMount() {
    const contacts = this.props.contacts.filter((v) => {
      return lodash.has(v, 'private.comment')
    });
    this.setState({
      contacts: lodash.sortBy(contacts, 'private.comment')
    });
  }

  handleSearch(e) {
    const s = removeAccents(e.target.value || '');
    const contacts = this.props.contacts.filter((v) => {
      return lodash.has(v, 'private.comment') &&
        (removeAccents(v.private.comment).toLowerCase().includes(s.toLowerCase())
          || (lodash.has(v, 'public.fn') && !!v.public.fn.toLowerCase().includes(s.toLowerCase()))
          || (lodash.has(v, 'public.cmsisdn') && v.public.cmsisdn.includes(s))
          || (lodash.has(v, 'topic') && Topic.getThreadId(v.topic) && Topic.getThreadId(v.topic).includes(s)));
    });
    this.setState({
      contacts: lodash.sortBy(contacts, 'private.comment')
    });
  }

  handleSelected(value, index) {
    this.setState({
      topicSelected: value
    })
  }

  handleSendContact() {
    const { tinode } = this.props
    const topicName = this.state.topicSelected
    const topicContact = tinode.getTopicByName(topicName);
    const contact = Topic.getThreadId(topicName)
    const name = topicContact.private && topicContact.private.comment ? topicContact.private.comment : topicContact.public.fn || contact
    this.props.handleOnSendContact(topicContact, contact, name)
    this.props.onClose();
  }

  render() {
    return (
      <Suspense fallback={<div className="panel-form-row"><FormattedMessage id="loading_note"
        defaultMessage="Loading..." description="Message shown when component is loading" /></div>}>
        <div className="dialog-container custom-dialog-container">
          <div className="dialog-background custom-dialog-background" onClick={this.props.onClose}>
          </div>
          <div className="dialog-content">
            <div className="contact">
              <div className="header">
                {<button className="back" onClick={this.props.onClose}>
                  <FormattedMessage id="dialog_button_cancel" defaultMessage={"Cancel"} />
                </button>}
                <div className="title">
                  <FormattedMessage id="dialog_title_contact" defaultMessage={"Account information"} />
                </div>
                {<button className="done" onClick={this.handleSendContact}>
                  <FormattedMessage id="dialog_button_share" defaultMessage={"Share"} />
                </button>}
              </div>
              <div className="search">
                <i className="icon">
                  <IconSearch />
                </i>
                <input type="text" name="" id="" className="search-input" placeholder="Tìm kiếm" onChange={this.handleSearch} />
              </div>
              <div className="contact-list">
                <ContactList
                  tinode={this.props.tinode}
                  contacts={this.state.contacts}
                  myUserId={undefined}
                  emptyListMessage={''}
                  showOnline={false}
                  topicSelected={this.state.topicSelected}
                  showUnread={false}
                  showContextMenu={false}
                  onTopicSelected={this.handleSelected}
                  onlyShowComment={true}
                  showContactMode={CONTACT_LIST_SHOW_MODE.PHONE_NUMBER}
                />
              </div>
            </div>
          </div>
        </div>
      </Suspense>

    )
  }
}

export default injectIntl(ShareContacts)
